import Button from '@blocks/Button'
import Flex from "@blocks/Flex"
import React, { useMemo } from 'react'
import { Column } from "react-table"
import { Options } from "../types"

export default function useActions<T extends object>(columns: Column<T>[], actions?: Options<T>["actions"]): Column<T>[] {
    return useMemo<Column<T>[]>(() => {
        if (!actions?.length) 
            return columns

        return [
            ...columns,
            {
                id: 'edit',
                Header: () => null,
                Cell: ({ row }: any) => {
                    return (
                        <Flex gap="10px">
                            {actions.map((action, idx) => {
                                if (action.condition) {
                                    if (!action.condition(row))
                                        return
                                }

                                return (
                                    <Button
                                        key={idx}
                                        type="tertiary"
                                        scheme="outline"
                                        onClick={() => action.action(row)}>
                                        {action.label}
                                    </Button>
                                )
                            })}
                        </Flex>
                    )
                },
                width: "auto"
            },
        ]
    }, [actions])

}